import { Checkbox } from '@timelyapp/react';
import { lowerCase, startCase, uniq } from 'lodash-es';
import React from 'react';
import { useSelector } from 'react-redux';
import { getAccountAvailableWeekdays } from 'redux/selectors/accounts';
import { sortBy } from 'utils/typesafe';
import type { Weekdays } from 'utils/work-days';
import { weekdayToFullDayMap, weekdayToNumberMap } from 'utils/work-days';

interface Props {
  onChange: (workdays: string) => void;
  workdays: string;
  type: 'short' | 'long';
  disabled?: boolean;
}

const WeekdaySelector: React.FC<Props> = ({
  onChange,
  workdays,
  type = 'long',
  disabled = false,
}) => {
  const allDays = useSelector(getAccountAvailableWeekdays);
  const selectedWorkdays = workdays.split(',') as Array<Weekdays>;
  const workdaysSet = new Set(selectedWorkdays);

  const sortDays = (a: Weekdays, b: Weekdays): number => {
    return weekdayToNumberMap[a] - weekdayToNumberMap[b];
  };

  const handleChange = (day: string, checked: boolean) => {
    if (checked) {
      const updatedDays = uniq([...selectedWorkdays, day]) as Array<Weekdays>;
      const checkedPayload = updatedDays.sort(sortDays);
      onChange(checkedPayload.join(','));
      return;
    }

    const payload = sortBy(
      selectedWorkdays.filter(workday => workday !== day),
      (day: Weekdays) => weekdayToNumberMap[day]
    );

    if (!payload.length) {
      return;
    }

    onChange(payload.join(','));
  };

  return (
    <ol style={{ display: type === 'short' ? 'flex' : 'initial' }}>
      {allDays.map(option => (
        <li key={option} style={{ marginRight: type === 'short' ? 15 : 5 }}>
          <Checkbox
            style={{ marginRight: type === 'short' ? 5 : 10 }}
            disabled={disabled || (workdaysSet.has(option) && workdaysSet.size === 1)}
            label={type === 'short' ? startCase(lowerCase(option)) : weekdayToFullDayMap[option]}
            checked={workdaysSet.has(option)}
            onChangeChecked={checked => handleChange(option, checked)}
          />
        </li>
      ))}
    </ol>
  );
};

export default WeekdaySelector;
